/* DISANGNI contextual feedback. No cart, cookie, storage or impression tracking. */
(() => {
  'use strict';
  if (window.DSGSiteFeedback) { window.DSGSiteFeedback.mount(); return; }
  const cfg = window.DSGFeedbackConfig || {};
  if (cfg.enabled === false) return;
  const ENDPOINT = 'https://feedback.disangni.com:8443/site-feedback/v1/submit';
  const VERSION = 'site-feedback-v1';
  const TYPES = ['home', 'collection', 'product', 'cart', 'member', 'help', 'policy', 'global-network', 'search', 'contact', 'other'];
  const locale = String(cfg.locale || window.Shopify?.locale || document.documentElement.lang || 'en').slice(0, 24);
  const EN = {
    footer: 'Share your feedback', product: 'Could these product details be clearer?', collection: 'Help us improve browsing',
    search: "Couldn’t find what you need? Share feedback", cart: 'Feedback on your shopping experience', member: 'Share feedback about your member space',
    title: 'We’re listening', intro: 'Tell us what worked well or what we could improve on this page.',
    question: 'Was this page helpful? (optional)', yes: 'Yes', no: 'Not quite',
    reasonLabel: 'What could we improve? (optional)', reasonPlaceholder: 'Choose a topic',
    unclear: 'Something is unclear', missing: 'Information or an option is missing', outdated: 'Information seems out of date', other: 'Something else',
    comment: 'Your feedback (optional)', placeholder: 'What would make your experience better?',
    privacy: 'Please do not include your name, order number, contact or payment details.',
    support: 'Need help with an order? Contact us', submit: 'Send feedback', sending: 'Sending…', close: 'Close', done: 'Done',
    empty: 'Please select an answer or topic, or leave a comment.',
    success: 'Thank you. Your feedback has been saved.', error: 'We couldn’t confirm your feedback was saved. Your message is still here. Please try again.',
    unavailable: 'Feedback is unavailable in this browser. Please use Contact us.', limit: 'Please keep your feedback within 1,000 characters.'
  };
  const ZH = {
    footer: '反馈与建议', product: '商品信息是否清楚？欢迎反馈', collection: '帮助我们改善选购体验',
    search: '没有找到想要的商品？告诉我们', cart: '反馈您的购物体验', member: '对会员中心提出建议',
    title: '倾听您的建议', intro: '欢迎告诉我们，这个页面有哪些做得好或需要改进的地方。',
    question: '这个页面对您有帮助吗？（选填）', yes: '有帮助', no: '还不够',
    reasonLabel: '您希望改进什么？（选填）', reasonPlaceholder: '选择一个方面',
    unclear: '有些内容不够清楚', missing: '缺少信息或选项', outdated: '信息可能需要更新', other: '其他建议',
    comment: '您的反馈（选填）', placeholder: '怎样能让您的体验更好？',
    privacy: '请勿填写姓名、订单号、联系方式或付款信息。', support: '需要订单帮助？联系我们',
    submit: '提交反馈', sending: '正在提交…', close: '关闭', done: '完成',
    empty: '请选择一个回答或反馈主题，或填写建议。', success: '谢谢，您的反馈已保存。',
    error: '暂时无法确认是否保存成功，您填写的内容仍在。请重试。',
    unavailable: '当前浏览器暂不支持反馈，请通过“联系我们”联系。', limit: '请将反馈控制在 1000 字以内。'
  };
  const labels = Object.assign({}, /^zh(?:-|$)/i.test(locale) ? ZH : EN);
  for (const key of Object.keys(labels)) {
    if (typeof cfg.labels?.[key] === 'string' && cfg.labels[key].trim()) labels[key] = cfg.labels[key];
  }
  let dialog, form, fields, status, submit, done, opener, state, pending = false, scrollBefore, fallbackInert = [];
  let mountTimer;
  const drafts = new Map();
  const watchedDrawers = new WeakSet();
  const make = (tag, cls, text) => {
    const node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text !== undefined) node.textContent = text;
    return node;
  };
  const query = (selector, within = document) => {
    try { return selector ? within.querySelector(selector) : null; } catch (_) { return null; }
  };
  const visible = node => !!node && node.getClientRects().length > 0 && !node.closest('[hidden],dialog:not([open])');
  const pageType = () => {
    if (TYPES.includes(cfg.pageType)) return cfg.pageType;
    const path = location.pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/|$)/i, '') || '/';
    if (/\/products\//.test(path)) return 'product';
    if (/^\/collections(?:\/|$)/.test(path)) return 'collection';
    if (/^\/cart\/?$/.test(path)) return 'cart';
    if (/^\/search\/?$/.test(path)) return 'search';
    if (/\/member-centre(?:\/|$)/.test(path) || /^\/account(?:\/|$)/.test(path)) return 'member';
    if (/\/help-center(?:\/|$)|\/returns-exchanges(?:\/|$)/.test(path)) return 'help';
    if (/^\/policies\//.test(path)) return 'policy';
    if (/\/contact-us(?:\/|$)/.test(path)) return 'contact';
    if (/\/global-(?:delivery|fulfillment|network)/.test(path)) return 'global-network';
    return path === '/' ? 'home' : 'other';
  };
  function context(placement) {
    const market = String(cfg.market || window.Shopify?.country || '').toUpperCase();
    const product = String(cfg.product || location.pathname.match(/\/products\/([^/]+)/)?.[1] || '').slice(0, 255);
    const data = {
      page_type: placement === 'cart-drawer' ? 'cart' : pageType(), path: location.pathname, placement: placement || 'footer', locale,
      market: /^[A-Z]{2}$/.test(market) ? market : '',
      device: matchMedia('(max-width:749px)').matches ? 'mobile' : matchMedia('(max-width:1023px)').matches ? 'tablet' : 'desktop',
      version: VERSION, is_test: false
    };
    if (product && data.page_type === 'product') data.product = product;
    return data;
  }
  function uuid() {
    if (typeof crypto?.randomUUID === 'function') return crypto.randomUUID();
    if (typeof crypto?.getRandomValues !== 'function') return null;
    const bytes = crypto.getRandomValues(new Uint8Array(16));
    bytes[6] = (bytes[6] & 15) | 64; bytes[8] = (bytes[8] & 63) | 128;
    const hex = Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('');
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
  }
  function close() {
    if (!dialog?.hasAttribute('open')) return;
    if (typeof dialog.close === 'function') dialog.close();
    else { dialog.removeAttribute('open'); onClose(); }
  }
  function onClose() {
    if (scrollBefore !== undefined) { document.documentElement.style.overflow = scrollBefore; scrollBefore = undefined; }
    for (const [node, previous] of fallbackInert) if (node.isConnected) node.inert = previous;
    fallbackInert = [];
    if (opener?.isConnected && visible(opener)) opener.focus({ preventScroll: true });
  }
  function update() {
    if (!state) return;
    fields.querySelectorAll('[data-answer]').forEach(button => {
      button.setAttribute('aria-pressed', String(state.helpful === (button.dataset.answer === 'yes')));
    });
    form.elements.reason.value = state.reason;
    form.elements.comment.value = state.comment;
    query('.dsgsf-count', form).textContent = `${state.comment.length} / 1000`;
    fields.hidden = !!state.saved;
    submit.hidden = !!state.saved;
    done.hidden = !state.saved;
    status.textContent = state.saved ? labels.success : (state.message || '');
    form.setAttribute('aria-busy', String(pending));
    form.querySelectorAll('button,textarea,select').forEach(node => { node.disabled = pending; });
    submit.textContent = pending ? labels.sending : labels.submit;
  }
  function change() {
    if (pending) return;
    const reason = form.elements.reason.value;
    const comment = form.elements.comment.value;
    if (reason !== state.reason || comment !== state.comment) {
      state.reason = reason; state.comment = comment;
      state.message = '';
    }
    query('.dsgsf-count', form).textContent = `${comment.length} / 1000`;
    status.textContent = state.message || '';
  }
  async function send(event) {
    event.preventDefault(); event.stopPropagation();
    if (pending || !state || state.saved) return;
    change();
    if (state.comment.length > 1000) { state.message = labels.limit; update(); return; }
    if (state.helpful === null && !state.reason && !state.comment.trim()) { state.message = labels.empty; update(); form.elements.comment.focus(); return; }
    if (!state.id) { state.message = labels.unavailable; update(); return; }
    pending = true; state.attempted = true; state.message = ''; update();
    const sendingState = state;
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 12000);
    const payload = Object.assign({}, state.context, { submission_id: state.id, helpful: state.helpful, reason: state.reason, comment: state.comment.trim() });
    try {
      const response = await fetch(ENDPOINT, {
        method: 'POST', credentials: 'omit', cache: 'no-store', referrerPolicy: 'no-referrer',
        headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload), signal: controller.signal
      });
      const result = await response.json();
      if (!response.ok || result?.ok !== true) throw new Error('unconfirmed');
      sendingState.saved = true;
    } catch (_) { sendingState.message = labels.error; }
    finally { clearTimeout(timer); pending = false; update(); }
  }
  function build() {
    dialog = make('dialog', 'dsgsf-dialog'); dialog.id = 'dsg-site-feedback';
    dialog.setAttribute('aria-labelledby', 'dsgsf-title'); dialog.setAttribute('aria-describedby', 'dsgsf-intro');
    dialog.setAttribute('aria-modal', 'true'); dialog.dataset.dsgsfOwned = '';
    const header = make('div', 'dsgsf-header');
    header.append(make('span', 'dsgsf-brand', 'DISANGNI'));
    const dismiss = make('button', 'dsgsf-close', '×'); dismiss.type = 'button'; dismiss.setAttribute('aria-label', labels.close); dismiss.onclick = close; header.append(dismiss);
    const body = make('div', 'dsgsf-body');
    const title = make('h2', '', labels.title); title.id = 'dsgsf-title'; title.tabIndex = -1;
    const intro = make('p', 'dsgsf-intro', labels.intro); intro.id = 'dsgsf-intro';
    form = make('form', 'dsgsf-form'); form.noValidate = true;
    fields = make('div', 'dsgsf-fields');
    const rating = make('fieldset', 'dsgsf-rating'); rating.append(make('legend', '', labels.question));
    for (const [value, text] of [['yes', labels.yes], ['no', labels.no]]) {
      const button = make('button', 'dsgsf-choice', text); button.type = 'button'; button.dataset.answer = value;
      button.setAttribute('aria-pressed', 'false');
      button.onclick = () => {
        if (pending) return;
        const next = value === 'yes'; state.helpful = state.helpful === next ? null : next;
        state.message = ''; update();
      };
      rating.append(button);
    }
    const reasonLabel = make('label', '', labels.reasonLabel); reasonLabel.htmlFor = 'dsgsf-reason';
    const reason = make('select'); reason.id = 'dsgsf-reason'; reason.name = 'reason';
    for (const [value, text] of [['', labels.reasonPlaceholder], ['unclear', labels.unclear], ['missing-answer', labels.missing], ['outdated', labels.outdated], ['other', labels.other]]) {
      const option = make('option', '', text); option.value = value; reason.append(option);
    }
    const commentLabel = make('label', '', labels.comment); commentLabel.htmlFor = 'dsgsf-comment';
    const comment = make('textarea'); comment.id = 'dsgsf-comment'; comment.name = 'comment'; comment.rows = 4;
    comment.maxLength = 1000; comment.placeholder = labels.placeholder; comment.setAttribute('aria-describedby', 'dsgsf-privacy');
    const count = make('span', 'dsgsf-count', '0 / 1000'); count.setAttribute('aria-hidden', 'true');
    const privacy = make('p', 'dsgsf-note', labels.privacy); privacy.id = 'dsgsf-privacy';
    const support = make('a', 'dsgsf-support', labels.support);
    const supportPath = typeof cfg.supportPath === 'string' && /^\/(?!\/)/.test(cfg.supportPath) ? cfg.supportPath : '/pages/contact-us';
    support.href = supportPath;
    fields.append(rating, reasonLabel, reason, commentLabel, comment, count, privacy, support);
    submit = make('button', 'dsgsf-submit', labels.submit); submit.type = 'submit';
    done = make('button', 'dsgsf-submit', labels.done); done.type = 'button'; done.hidden = true; done.onclick = close;
    status = make('p', 'dsgsf-status'); status.setAttribute('role', 'status'); status.setAttribute('aria-live', 'polite'); status.setAttribute('aria-atomic', 'true');
    form.append(fields, status, submit, done); body.append(title, intro, form); dialog.append(header, body); document.body.append(dialog);
    form.addEventListener('submit', send); form.addEventListener('input', change); form.addEventListener('change', change);
    dialog.addEventListener('close', onClose);
    dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
    dialog.addEventListener('click', event => {
      const rect = dialog.getBoundingClientRect();
      if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) close();
    });
    dialog.addEventListener('keydown', event => {
      if (event.key === 'Escape') { event.preventDefault(); close(); return; }
      if (event.key !== 'Tab') return;
      const nodes = Array.from(dialog.querySelectorAll('a[href],button:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex="0"]')).filter(visible);
      const first = nodes[0], last = nodes[nodes.length - 1];
      if (!first) { event.preventDefault(); title.focus(); return; }
      if (event.shiftKey && (document.activeElement === first || document.activeElement === title)) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
  }
  function open(button) {
    if (pending && state) { /* Reopen the pending form without changing its source. */ }
    else {
      const data = context(button?.dataset.dsgFeedbackOpen);
      const key = `${data.path}|${data.placement}`;
      state = drafts.get(key);
      if (!state || state.saved) {
        state = { id: uuid(), helpful: null, reason: '', comment: '', context: data, saved: false, attempted: false, message: '' };
        drafts.set(key, state);
      }
    }
    opener = button || document.activeElement;
    if (!dialog) build(); update();
    if (!dialog.hasAttribute('open')) {
      scrollBefore = document.documentElement.style.overflow; document.documentElement.style.overflow = 'hidden';
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else {
        dialog.setAttribute('open', ''); dialog.classList.add('dsgsf-fallback'); dialog.setAttribute('role', 'dialog');
        fallbackInert = Array.from(document.body.children).filter(node => node !== dialog).map(node => [node, node.inert]);
        fallbackInert.forEach(([node]) => { node.inert = true; });
      }
    }
    query('.dsgsf-body', dialog).scrollTop = 0;
    query('#dsgsf-title', dialog).focus({ preventScroll: true });
  }
  function link(placement, text, contextType) {
    const wrap = make('div', `dsgsf-entry dsgsf-entry--${placement}`); wrap.dataset.dsgsfOwned = '';
    if (contextType) wrap.dataset.dsgsfContext = contextType;
    const button = make('button', 'dsgsf-trigger', text); button.type = 'button'; button.dataset.dsgFeedbackOpen = placement;
    button.setAttribute('aria-haspopup', 'dialog'); button.setAttribute('aria-controls', 'dsg-site-feedback');
    wrap.append(button); return wrap;
  }
  function mount() {
    if (!document.body) return;
    mountDrawers();
    const type = pageType(), main = query('main#MainContent,main,[role="main"]') || document.body;
    const footer = query(cfg.selectors?.footer) || query('#member-app .footer') || query('.site-footer .page-width') || query('.site-footer') || Array.from(document.querySelectorAll('footer')).find(node => !node.closest('dialog,#CartDrawer'));
    if (footer && !query('.dsgsf-entry--footer')) footer.append(link('footer', labels.footer));
    document.querySelectorAll('[data-dsgsf-context]').forEach(node => { if (node.dataset.dsgsfContext !== type) node.remove(); });
    if (query('[data-dsgsf-context]')) return;
    let target, position = 'afterend';
    if (type === 'product') {
      const meta = query('.product-single__meta', main) || main;
      target = query(cfg.selectors?.product, main) || Array.from(meta.querySelectorAll('.variant-wrapper,.variant-input-wrap')).filter(visible).pop();
      if (target?.classList.contains('variant-input-wrap')) target = target.closest('.variant-wrapper') || target;
    } else if (type === 'collection') {
      target = query(cfg.selectors?.collection, main) || query('.collection-filter,.collection-toolbar,.collection-filters', main) || query('#CollectionAjaxContent .dsg-collection-nav', main);
    } else if (type === 'search') {
      if (query('.grid-product,.product-grid-item,[data-product-id]', main)) return;
      target = query(cfg.selectors?.search, main) || query('form[action*="/search"]', main);
    } else if (type === 'cart') {
      target = query(cfg.selectors?.cart, main) || query('.cart__checkout,[name="checkout"]', main);
    } else if (type === 'member') {
      target = query(cfg.selectors?.member, main) || query('#member-app .main .member-market', main);
      if (!target) { target = query('#member-app .main,.account-main,.member-main,.member-content', main); position = 'afterbegin'; }
    }
    if (target && visible(target) && labels[type]) target.insertAdjacentElement(position, link(`${type}-context`, labels[type], type));
  }
  function mountDrawers() {
    for (const drawer of document.querySelectorAll('#CartDrawer,dialog.member-bag')) {
      if (!watchedDrawers.has(drawer)) {
        watchedDrawers.add(drawer);
        new MutationObserver(scheduleMount).observe(drawer, { attributes: true, attributeFilter: ['open', 'class', 'hidden', 'aria-hidden'] });
      }
      const rect = drawer.getBoundingClientRect();
      const openNow = drawer.tagName === 'DIALOG' ? drawer.hasAttribute('open') : visible(drawer) && getComputedStyle(drawer).visibility !== 'hidden' && rect.left < innerWidth && rect.right > 0;
      if (!openNow || query('.dsgsf-entry--cart-drawer', drawer)) continue;
      const target = query('.bag-actions,.drawer__footer .cart__checkout-wrapper,.drawer__fixed-footer .cart__checkout-wrapper', drawer);
      const footer = query('.drawer__footer,.drawer__fixed-footer,footer', drawer);
      if (target) target.insertAdjacentElement('afterend', link('cart-drawer', labels.cart));
      else if (footer) footer.append(link('cart-drawer', labels.cart));
    }
  }
  function scheduleMount() { clearTimeout(mountTimer); mountTimer = setTimeout(mount, 180); }
  document.addEventListener('click', event => {
    const button = event.target.closest?.('[data-dsg-feedback-open]');
    if (!button) return;
    event.preventDefault(); event.stopPropagation(); open(button);
  });
  window.DSGSiteFeedback = Object.freeze({ version: VERSION, mount, open, close });
  function ready() {
    mount();
    new MutationObserver(records => {
      if (records.some(record => !record.target.closest?.('[data-dsgsf-owned]') && Array.from(record.addedNodes).some(node => node.nodeType === 1 && !node.hasAttribute('data-dsgsf-owned')))) scheduleMount();
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true }); else ready();
  document.addEventListener('shopify:section:load', scheduleMount);
  window.addEventListener('popstate', scheduleMount); window.addEventListener('hashchange', scheduleMount);
})();
